import { render, staticRenderFns } from "./SiteReport.vue?vue&type=template&id=248ae1cf&scoped=true"
import script from "./SiteReport.vue?vue&type=script&lang=js"
export * from "./SiteReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248ae1cf",
  null
  
)

export default component.exports